import defaultsdeep from 'lodash.defaultsdeep';
import { importWithReload } from 'config/ChunkReload';

export const whitelabelConfig = async (name = 'edusynch') => {
  const map = {
    edusynch: () => importWithReload(() => import('./edusynch')),
    berlitz: () => importWithReload(() => import('./berlitz')),
  };

  const selectedWhitelabel = map[name];
  if (!selectedWhitelabel) {
    throw new Error(`Invalid '${name}' whitelabel`);
  }

  const { factory } = await selectedWhitelabel();
  if (name === 'edusynch') {
    return factory();
  }

  const selectedWhitelabelProps = await factory();
  const { factory: defaultWhitelabelFactort } = await map.edusynch();
  const defaults = defaultWhitelabelFactort({
    colors: selectedWhitelabelProps.colors,
  });

  return defaultsdeep(selectedWhitelabelProps, defaults);
};
